import { createAction } from '@reduxjs/toolkit';
import { IUserToUpdate, User } from '../models/user.model';
import { IUserState } from './user.reducer';
import { DeliveryAddress, DeliveryPoint } from '../models/address';
import { UserOrder } from '../models/user-order.model';

export const USER_AUTOLOGIN = '[User] USER_AUTOLOGIN';
export const USER_LOGIN = '[User] USER_LOGIN';
export const USER_SAVE = '[User] USER_SAVE';
export const USER_UPDATE = '[User] USER_UPDATE';
export const USER_SEND_CODE = '[User] USER_SEND_CODE';
export const USER_LOGOUT = '[User] USER_LOGOUT';
export const USER_FETCHING_ORDERS = '[User] USER_FETCHING_ORDERS';
export const USER_FETCHED_ORDERS = '[User] USER_FETCHED_ORDERS';
export const USER_UPDATE_ORDER = '[User] USER_UPDATE_ORDER';
export const USER_FETCHING_INFO = '[User] USER_FETCHING_INFO';
export const USER_NEED_TO_FETCH_ORDERS = '[User] USER_NEED_TO_FETCH_ORDERS';

export const USER_ADD_ADDRESS = '[User] USER_ADD_ADDRESS';
export const USER_STORE_ADDRESS = '[User] USER_STORE_ADDRESS';
export const USER_UPDATING_ADDRESS = '[User] USER_UPDATING_ADDRESS';
export const USER_UPDATE_ADDRESSES = '[User] USER_UPDATE_ADDRESSES';

export const USER_SUCCESS_AUTH_BACK_PAGE = '[User] SUCCESS_AUTH_BACK_PAGE';

export const userAutoLoginAction = createAction<IUserState>(USER_AUTOLOGIN);
export const userNeedToFetchOrdersAction = createAction<void>(USER_NEED_TO_FETCH_ORDERS);
export const userLoginAction = createAction<{ organizationCode: string; authToken: string; user: User; }>(USER_LOGIN);
export const userSaveAction = createAction<User>(USER_SAVE);
export const userUpdatingAddressAction = createAction<{ id: string, deliveryPoint: DeliveryPoint }>(USER_UPDATING_ADDRESS);
export const userAddAddressAction = createAction<DeliveryPoint>(USER_ADD_ADDRESS);
export const userStoreAddressesAction = createAction<DeliveryAddress>(USER_STORE_ADDRESS);
export const userUpdateAddressesAction = createAction<DeliveryAddress[]>(USER_UPDATE_ADDRESSES);
export const userUpdateAction = createAction<IUserToUpdate>(USER_UPDATE);
export const userSendCodeAction = createAction<{ organizationCode: string; phone: number; isCodeSentEarlier: boolean; }>(USER_SEND_CODE);
export const userFetchingOrdersAction = createAction<void>(USER_FETCHING_ORDERS);
export const userStoreOrdersAction = createAction<UserOrder[]>(USER_FETCHED_ORDERS);
export const userStoreUpdateOrderAction = createAction<UserOrder>(USER_UPDATE_ORDER);
export const userFetchingInfoAction = createAction<void>(USER_FETCHING_INFO);
export const userLogoutAction = createAction<void>(USER_LOGOUT);
export const successAuthBackPage = createAction<string>(USER_SUCCESS_AUTH_BACK_PAGE);
